import { render, staticRenderFns } from "./SharedChannelSettings.vue?vue&type=template&id=6db9c3cf&scoped=true&"
import script from "./SharedChannelSettings.vue?vue&type=script&lang=js&"
export * from "./SharedChannelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9c3cf",
  null
  
)

export default component.exports